 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"configurar":"configurar","login":"login","favoritos":"favoritos","pedidos":"pedidos"}[chunkId]||chunkId) + "." + {"chunk-0f60e6af":"47107dee","chunk-1009d81e":"602e1411","chunk-151d1bbf":"fa2e26e3","chunk-277c6ee7":"f2b02ac5","chunk-2c57efa2":"8c421fe1","chunk-2d0b9632":"2d2618b1","chunk-2d0c1ae7":"da743fb5","chunk-2d0c78e5":"d95f67d2","chunk-2d0e186f":"d74d53e8","chunk-2d225005":"962cf7cb","chunk-2d230ff4":"df739fa8","chunk-38ccfe28":"b56b1e76","chunk-3cb9782e":"08bab9ce","chunk-3f142b7e":"4b6effa9","chunk-3f7e6e5c":"fd6c41bc","chunk-4405e632":"06a0c603","chunk-45b48dac":"0cbbde5f","chunk-4c9c71c2":"aa9f7839","chunk-77bdedbe":"5871a6df","configurar":"71a8a655","login":"e8871088","chunk-4d188462":"86e9f80c","chunk-51f43c34":"e4bf18a8","chunk-5a5184d0":"09aa2ebd","chunk-5abf358c":"ab0974d3","chunk-5de1c79e":"b3a8d930","chunk-60a83e90":"efad609c","chunk-6d248fca":"6d86d5d8","chunk-791dc1f5":"43e5b7cf","chunk-7fa83cac":"d258b5b7","chunk-cd5f171e":"4c1eb00b","chunk-e9cb7634":"074994b4","chunk-f0743dac":"ba7447de","favoritos":"33be9268","pedidos":"c83963e3","chunk-2d0e149b":"c22f685e","chunk-5345ed26":"c44ca69d","chunk-2597ac56":"4ed71b2d","chunk-2d237991":"d424b364","chunk-29a0125b":"18bc39aa","chunk-2d0b6388":"3bf4be4b","chunk-2d0c203c":"06a4c750","chunk-354ea696":"1c1599d9","chunk-35c0595c":"154a42d0","chunk-416d73c9":"cbb34f52","chunk-5cd26a06":"2dc28c98","chunk-651e7c17":"17fc6611","chunk-9138a82a":"d2b1e3d4","chunk-f32b2202":"3ac75111","chunk-2d0b95f3":"885066ca","chunk-2d21d4f2":"47c5fb79","chunk-71ab6ab7":"06cff6d9","chunk-8fb0d0c2":"bf10578a","chunk-66b7d1e1":"4da64975","chunk-0ebc9c34":"981b99f2","chunk-119cdd0b":"62ddab9c","chunk-2d0bd236":"90306844","chunk-64dfb121":"3d5abc91","chunk-6cdd03ac":"a16914a0","chunk-a1c50a98":"b132a22d","chunk-b6300db2":"c2f129ad","chunk-33b3f790":"5aefd58c","chunk-41620a69":"e37612f1","chunk-248d5f53":"94179640","chunk-2d0a4f12":"498d42de","chunk-2d0be13b":"b43f7b2f","chunk-2d20826c":"d3838794","chunk-660e9f78":"bf781473","chunk-14fb9cd0":"63fc5754","chunk-19110b4a":"303127e9","chunk-1a7f706b":"92f2a90e","chunk-2d0aeafb":"e584506e","chunk-2d0bd52d":"4d98aae1","chunk-2d0d09fa":"5fe1093e","chunk-3ffab950":"392f67ff","chunk-4adb90f6":"9a55ce00","chunk-7570903b":"47a97c3e","chunk-a81d957e":"419165e9","chunk-2d0dcff4":"8f4b0b45","chunk-2d2085ee":"1dbceab5","chunk-2d208fc1":"198eafee","chunk-6798f89b":"68e65ea2","chunk-6a0116ec":"f0767832","chunk-768b32d2":"024ddf7e","chunk-2d0b381d":"f5d21a07"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0f60e6af":1,"chunk-1009d81e":1,"chunk-277c6ee7":1,"chunk-2c57efa2":1,"chunk-38ccfe28":1,"chunk-3f142b7e":1,"chunk-3f7e6e5c":1,"chunk-4405e632":1,"chunk-45b48dac":1,"chunk-77bdedbe":1,"configurar":1,"login":1,"chunk-4d188462":1,"chunk-51f43c34":1,"chunk-5a5184d0":1,"chunk-5abf358c":1,"chunk-5de1c79e":1,"chunk-60a83e90":1,"chunk-6d248fca":1,"chunk-791dc1f5":1,"chunk-7fa83cac":1,"chunk-e9cb7634":1,"chunk-f0743dac":1,"favoritos":1,"pedidos":1,"chunk-2597ac56":1,"chunk-29a0125b":1,"chunk-354ea696":1,"chunk-35c0595c":1,"chunk-416d73c9":1,"chunk-5cd26a06":1,"chunk-651e7c17":1,"chunk-9138a82a":1,"chunk-f32b2202":1,"chunk-71ab6ab7":1,"chunk-8fb0d0c2":1,"chunk-66b7d1e1":1,"chunk-0ebc9c34":1,"chunk-119cdd0b":1,"chunk-64dfb121":1,"chunk-6cdd03ac":1,"chunk-a1c50a98":1,"chunk-b6300db2":1,"chunk-33b3f790":1,"chunk-41620a69":1,"chunk-248d5f53":1,"chunk-660e9f78":1,"chunk-14fb9cd0":1,"chunk-19110b4a":1,"chunk-1a7f706b":1,"chunk-3ffab950":1,"chunk-4adb90f6":1,"chunk-7570903b":1,"chunk-a81d957e":1,"chunk-6798f89b":1,"chunk-6a0116ec":1,"chunk-768b32d2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"configurar":"configurar","login":"login","favoritos":"favoritos","pedidos":"pedidos"}[chunkId]||chunkId) + "." + {"chunk-0f60e6af":"594969f3","chunk-1009d81e":"63f36f3d","chunk-151d1bbf":"31d6cfe0","chunk-277c6ee7":"e02b3d1f","chunk-2c57efa2":"cffad614","chunk-2d0b9632":"31d6cfe0","chunk-2d0c1ae7":"31d6cfe0","chunk-2d0c78e5":"31d6cfe0","chunk-2d0e186f":"31d6cfe0","chunk-2d225005":"31d6cfe0","chunk-2d230ff4":"31d6cfe0","chunk-38ccfe28":"5dfc931a","chunk-3cb9782e":"31d6cfe0","chunk-3f142b7e":"0ebfe33d","chunk-3f7e6e5c":"8ca5bbf0","chunk-4405e632":"49533c1e","chunk-45b48dac":"f5eaaf42","chunk-4c9c71c2":"31d6cfe0","chunk-77bdedbe":"4032d0f4","configurar":"21dbea43","login":"83257ff9","chunk-4d188462":"d0c0c9c3","chunk-51f43c34":"c4f053d2","chunk-5a5184d0":"493e64ef","chunk-5abf358c":"c2270bab","chunk-5de1c79e":"61af0fbc","chunk-60a83e90":"ee44dd1e","chunk-6d248fca":"30014294","chunk-791dc1f5":"fab1a64b","chunk-7fa83cac":"c0788d7e","chunk-cd5f171e":"31d6cfe0","chunk-e9cb7634":"e520e583","chunk-f0743dac":"2262fb1a","favoritos":"4bce09d8","pedidos":"740995b4","chunk-2d0e149b":"31d6cfe0","chunk-5345ed26":"31d6cfe0","chunk-2597ac56":"8acb10c3","chunk-2d237991":"31d6cfe0","chunk-29a0125b":"7b42758e","chunk-2d0b6388":"31d6cfe0","chunk-2d0c203c":"31d6cfe0","chunk-354ea696":"6430b842","chunk-35c0595c":"7736fd9b","chunk-416d73c9":"1c1a09d2","chunk-5cd26a06":"36fd9ce3","chunk-651e7c17":"f13d1b7e","chunk-9138a82a":"175e5435","chunk-f32b2202":"29a8ea01","chunk-2d0b95f3":"31d6cfe0","chunk-2d21d4f2":"31d6cfe0","chunk-71ab6ab7":"2f3c6ed2","chunk-8fb0d0c2":"f7fe1825","chunk-66b7d1e1":"183cd887","chunk-0ebc9c34":"38e5bd88","chunk-119cdd0b":"4e054daf","chunk-2d0bd236":"31d6cfe0","chunk-64dfb121":"0ab50947","chunk-6cdd03ac":"95e78945","chunk-a1c50a98":"553b31b7","chunk-b6300db2":"2c15c81f","chunk-33b3f790":"273a6ad0","chunk-41620a69":"b6d6d8f9","chunk-248d5f53":"36a20d09","chunk-2d0a4f12":"31d6cfe0","chunk-2d0be13b":"31d6cfe0","chunk-2d20826c":"31d6cfe0","chunk-660e9f78":"cd5fc97c","chunk-14fb9cd0":"8384fdc7","chunk-19110b4a":"c57487b5","chunk-1a7f706b":"0e099750","chunk-2d0aeafb":"31d6cfe0","chunk-2d0bd52d":"31d6cfe0","chunk-2d0d09fa":"31d6cfe0","chunk-3ffab950":"93ff1f13","chunk-4adb90f6":"c6437479","chunk-7570903b":"01212ce5","chunk-a81d957e":"93b00670","chunk-2d0dcff4":"31d6cfe0","chunk-2d2085ee":"31d6cfe0","chunk-2d208fc1":"31d6cfe0","chunk-6798f89b":"d4ecac1f","chunk-6a0116ec":"3e41a13e","chunk-768b32d2":"e80e9450","chunk-2d0b381d":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
